var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPalaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288 0c-17.7 0-32 14.3-32 32v64H224V64h-32v32h-32V64h-32v32H96V64H64v32H32v32H0v64h576V128h-32V96h-32V64h-32v32h-32V64h-32v32h-32V64h-32v32h-32V32c0-17.7-14.3-32-32-32zm-96 192c-17.7 0-32 14.3-32 32v64H96v160h384V288h-64v-64c0-17.7-14.3-32-32-32H192zm-32 96h64v64h-64v-64zm96 0h64v64h-64v-64zm96 0h64v64h-64v-64z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalaceIcon);
export default __webpack_public_path__ + "static/media/palace-icon.a9952d773578dc2f2ee7090ff08f27e5.svg";
export { ForwardRef as ReactComponent };